import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import { Button } from 'reactstrap';

import './fonts/opensans/index.css'
import "./bootstrap.css";
import './index.scss'

const TemplateWrapper = ({ children }) =>
  <div style={{height: '100%'}}>

    <div className="wrapper">
      <div className="header-row">
        <div className="container-fluid">
          <Header />
        </div>
      </div>
      <div className="body-row">
        <div className="container-fluid">
          {children()}
        </div>
      </div>
    </div>
    <div className="footer-row">
      <div className="container-fluid">
        <Footer/>
      </div>
    </div>
  </div>

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.jsx